import React from 'react'

export function Menu(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <path d="M3 6H21" strokeWidth="2" strokeLinecap="round" />
    <path d="M3 12H21" strokeWidth="2" strokeLinecap="round" />
    <path d="M3 18H21" strokeWidth="2" strokeLinecap="round" />
  </svg>
}
